import React, { useMemo, useEffect } from 'react';
import { Grid, Paper } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import moment from 'moment';
import { liveTrackinglayoutSelector } from '../../../features/layout/layoutSlice';
import { useSelector } from 'react-redux';
import { useTable } from 'react-table';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useTheme } from '@mui/material/styles';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: 'Silver',
        color: useTheme().palette.common.black,
        fontSize: 13,
        fontStyle: 'bold'
    },
    body: {
        fontSize: 13,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: useTheme().palette.action.hover,
        },
    },
}))(TableRow);

const GeneralInformation = ({ reportData }) => {

    const dimentions = useSelector(liveTrackinglayoutSelector);

    const tableData = useMemo(() => {
        if (reportData.reportRecords && reportData.reportRecords.length > 0) {
            return reportData.reportRecords.map(item => {
                return {
                    vehicle: item.assetName,
                    start: moment(item.startTime).format('D/M/Y hh:mm A'),
                    end: moment(item.endTime).format('D/M/Y hh:mm A'),
                    stopDuration: item.stopDuration,
                    driveDuration: item.driveDuration,
                    routeLength: item.routeLength === 'No Data' ? 'No Data' : `${item.routeLength.toFixed(2)} Km`,
                    topSpeed: item.topSpeed === 'No Data' ? 'No Data' : `${item.topSpeed.toFixed(2)} Km/h`,
                    averageSpeed: item.averageSpeed === 'No Data' ? 'No Data' : `${item.averageSpeed.toFixed(2)} Km/h`,
                    key: item.assetName,
                };
            })
        } else {
            return [];
        }

    }, [reportData]);

    /*useEffect(() => {
        //console.log("Reoport data", reportData);
    }, [reportData])*/

    const tableColumns = useMemo(() => {
        return [
            { Header: 'Vehicle', accessor: 'vehicle' },
            { Header: 'Start', accessor: 'start' },
            { Header: 'End', accessor: 'end' },
            { Header: 'Stop Duration', accessor: 'stopDuration' },
            { Header: 'Drive Duration', accessor: 'driveDuration' },
            { Header: 'Distance', accessor: 'routeLength' },
            { Header: 'Top Speed', accessor: 'topSpeed' },
            { Header: 'Average Speed', accessor: 'averageSpeed' },
        ];
    }, []);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns: tableColumns, data: tableData });

    if (reportData && reportData.reportRecords && reportData.reportRecords.length > 0) {
        return (
            <Paper style={{ ...dimentions.reportDetailViewBottom, overflow: 'auto' }}>
                <div style={{ margin: '10px' }}>
                    <Grid container spacing={1}>
                        <Grid item sm={12} container>
                            <TableContainer component={Paper}>
                                <Table  {...getTableProps()}>
                                    <TableHead>
                                        {headerGroups.map(headerGroup => (
                                            <TableRow {...headerGroup.getHeaderGroupProps()}>
                                                {headerGroup.headers.map(column => (
                                                    <StyledTableCell
                                                        {...column.getHeaderProps()}
                                                    >
                                                        <b>{column.render('Header')}</b>
                                                    </StyledTableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableHead>
                                    <TableBody {...getTableBodyProps()}>
                                        {rows.map((row) => {
                                            prepareRow(row)
                                            return (
                                                <StyledTableRow {...row.getRowProps()}>
                                                    {row.cells.map(cell => {
                                                        return (
                                                            <StyledTableCell
                                                                {...cell.getCellProps()}
                                                            >
                                                                {cell.render('Cell')}
                                                            </StyledTableCell>
                                                        )
                                                    })}
                                                </StyledTableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </div>
            </Paper>
        );
    } else {
        return null;
    }

}

export default GeneralInformation;